import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { API } from '../../config/api';

const { setSucursal, setSucursalesList, setLoading, setError } = actions;

const fetchSucursales = () => {
  return async dispatch => {
    try {
      dispatch(setLoading(true));
      // Endpoint correcto: /sucursales/active
      const response = await DataService.get(`${API.pos.sucursales}/active`);
      // El backend retorna un array directo, no un objeto con results
      const sucursales = Array.isArray(response.data) ? response.data : response.data.results || [];
      dispatch(setSucursalesList(sucursales));
      return sucursales;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || 'Error al obtener sucursales';
      dispatch(setError(errorMessage));
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  };
};

const selectSucursal = sucursal => {
  return dispatch => {
    dispatch(setSucursal(sucursal));
  };
};

const clearSucursal = () => {
  return dispatch => {
    dispatch(setSucursal(null));
  };
};

const loadSucursalFromStorage = () => {
  // La sucursal ya se carga desde localStorage en el reducer initState
  // Esta función es para forzar una recarga si es necesario
  return (dispatch, getState) => {
    const currentSucursal = getState().sucursal.current;
    if (currentSucursal) {
      dispatch(setSucursal(currentSucursal));
    }
  };
};

export { fetchSucursales, selectSucursal, clearSucursal, loadSucursalFromStorage };
